import React from "react"
import { Dispatch } from "redux"

import {
    SetCcReviewComplianceHref,
    SetCcReviewHref,
    addModal,
} from "client/store"

import ReviewComplianceAnswer from "client/pages/cc/review/compliance/answer"

const Open = (
    baseRoute: string,
    activeTab: string,
    fileId: number,
    versionId: number,
    setId: number,
    revisionId: number,
    complianceItemId: number,
    dispatch: Dispatch,
) => {
    SetCcReviewComplianceHref(baseRoute, activeTab, fileId, versionId, setId, revisionId, complianceItemId)
    dispatch(addModal({
        key: "answer",
        content: (
            <ReviewComplianceAnswer
                setId={setId}
                revisionId={revisionId}
                complianceItemId={complianceItemId}
            />
        ),
        onClose: () => {
            SetCcReviewHref(baseRoute, activeTab, fileId, versionId)
        },
    }))
}
export default Open
